function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.3 20C39.2389 20 40.0075 20.7625 39.9278 21.698C39.5743 25.8481 37.9315 29.8003 35.2081 32.989C32.1154 36.6101 27.8321 39.0088 23.1287 39.7538C18.4253 40.4987 13.6104 39.541 9.55003 37.0528C5.4897 34.5646 2.45043 30.7093 0.97887 26.1803C-0.492688 21.6514 -0.299953 16.7459 1.52241 12.3463C3.34477 7.94676 6.67716 4.3418 10.9202 2.17987C15.1632 0.0179387 20.0384 -0.55908 24.6689 0.552601C28.7464 1.53152 32.3985 3.7633 35.1239 6.91298C35.7382 7.62297 35.5646 8.69167 34.805 9.24353C34.0454 9.79539 32.9884 9.62005 32.3618 8.92087C30.1214 6.42104 27.1651 4.6485 23.8752 3.85866C20.0319 2.93596 15.9855 3.41489 12.4638 5.20929C8.94204 7.0037 6.17616 9.99581 4.6636 13.6475C3.15104 17.2991 2.99107 21.3706 4.21246 25.1297C5.43386 28.8887 7.95645 32.0886 11.3265 34.1538C14.6966 36.219 18.693 37.0139 22.5968 36.3956C26.5007 35.7773 30.0558 33.7864 32.6227 30.7808C34.8201 28.2081 36.1699 25.0364 36.5131 21.6971C36.609 20.7632 37.3611 20 38.3 20Z",
  fill: "url(#paint0_angular)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.3 20C39.2389 20 40.0075 20.7625 39.9278 21.698C39.5743 25.8481 37.9315 29.8003 35.2081 32.989C32.1154 36.6101 27.8321 39.0088 23.1287 39.7538C18.4253 40.4987 13.6104 39.541 9.55003 37.0528C5.4897 34.5646 2.45043 30.7093 0.97887 26.1803C-0.492688 21.6514 -0.299953 16.7459 1.52241 12.3463C3.34477 7.94676 6.67716 4.3418 10.9202 2.17987C15.1632 0.0179387 20.0384 -0.55908 24.6689 0.552601C28.7464 1.53152 32.3985 3.7633 35.1239 6.91298C35.7382 7.62297 35.5646 8.69167 34.805 9.24353C34.0454 9.79539 32.9884 9.62005 32.3618 8.92087C30.1214 6.42104 27.1651 4.6485 23.8752 3.85866C20.0319 2.93596 15.9855 3.41489 12.4638 5.20929C8.94204 7.0037 6.17616 9.99581 4.6636 13.6475C3.15104 17.2991 2.99107 21.3706 4.21246 25.1297C5.43386 28.8887 7.95645 32.0886 11.3265 34.1538C14.6966 36.219 18.693 37.0139 22.5968 36.3956C26.5007 35.7773 30.0558 33.7864 32.6227 30.7808C34.8201 28.2081 36.1699 25.0364 36.5131 21.6971C36.609 20.7632 37.3611 20 38.3 20Z",
  fill: "url(#paint1_radial)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_angular",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20 20) scale(20)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F3F3F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.904854,
  stopColor: "#F3F3F3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20 20) rotate(90) scale(20)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.9ccbf702.svg";
export { ForwardRef as ReactComponent };